<template>
  <div>
    <!-- <InnerHeader /> -->
    <div class="page-content">
      <div class="container py-md-5 py-4">
        <div class="mb-5" v-if="isShow && !loader">
          <h2 class="text-center">Reset Password</h2>
        </div>
        <div class="col-12 row mb-3">
          <div class="col-md-4"></div>

          <div
            class="modal-body col-12 form-style"
            style="align-content: center; display: contents"
            v-if="isShow && !loader"
          >
            <Form @submit="resetPassword()">
              <div class="form-group col-12 mb-3">
                <label>New Password</label>
                <div class="input-group mb-3">
                  <Field
                    :type="newPasswordFieldType"
                    id="password"
                    name="password"
                    class="form-control password"
                    placeholder="New Password"
                    v-model="reset.password"
                    v-on:keydown.space="$event.preventDefault()"
                    rules="required:New Password|minLength:6|password"
                    :validateOnInput="true"
                  /><span
                    class="input-group-text"
                    id="basic-addon2"
                    style="border-radius: 0px 8px 8px 0px"
                    ><a v-on:click="switchVisibilityNew" class="psw-icon"
                      ><img :src="imageNew" width="20" /></a
                  ></span>
                </div>
                <ErrorMessage name="password" class="validation-msg" />
              </div>
              <div class="form-group col-12 mb-3">
                <label>Confirm Password</label>
                <div class="input-group mb-3">
                  <Field
                    :type="PasswordFieldType"
                    id="confirm_password"
                    name="confirm password"
                    class="form-control password"
                    placeholder="confirm Password"
                    v-on:keydown.space="$event.preventDefault()"
                    rules="required:confirm Password|confirmed:@password"
                    :validateOnInput="true"
                  /><span
                    class="input-group-text"
                    id="basic-addon2"
                    style="border-radius: 0px 8px 8px 0px"
                    ><a v-on:click="switchVisibility" class="psw-icon"
                      ><img :src="image" width="20" /></a
                  ></span>
                </div>
                <ErrorMessage name="confirm password" class="validation-msg" />
              </div>
              <div class="col-12 text-center mt-5">
                <button id="submit-button" class="btn btn-brand-1 btn-block">
                  Submit
                </button>
              </div>
            </Form>
          </div>
          <div
            class="modal-body pt-0 form-style"
            v-if="(!isShow && !loader) || !token"
          >
            <div class="col-12 text-center">
              <div
                class="col-12 text-center"
                style="align-items: center; display: block ruby"
              >
                <img
                  style="display: block; border: 0px none; margin-bottom: 126px"
                  src="/img/fail-icon.png"
                  width="125"
                  height="120"
                />
              </div>
              <div class="col-12 text-center">
                <h2
                  style="
                    font-size: 35px;
                    font-weight: 883;
                    line-height: 42px;
                    color: rgb(51, 51, 51);
                    margin-right: 15px;
                    margin-left: 41px;
                  "
                >
                  Sorry! Invalid link or token expired!
                </h2>
              </div>
            </div>
          </div>
          <div class="modal-body pt-0 form-style" v-show="loader">
            <div
              class="text-center"
              style="background: white; border-radius: 0 0 16px 16px"
            >
              <img src="/img/loader.gif" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <MainFooter /> -->
  </div>
</template>
<script>
// import InnerHeader from "@/components/InnerHeader";
// import MainFooter from "@/components/MainFooter";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  name: "ResetPassword",
  components: {
    // InnerHeader,
    // MainFooter,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loader: true,
      isShow: false,
      token: localStorage.getItem("token"),
      // oldPasswordFieldType: "password",
      newPasswordFieldType: "password",
      PasswordFieldType: "password",
      image: "/images/show-psw.svg",
      imageNew: "/images/show-psw.svg",
      // imageOld: "/images/show-psw.svg",
      reset: {
        token: "",
      },
    };
  },
  mounted() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      var Obj = {};
      Obj.token = this.token;
      this.$api
        .postAPI({
          _action: "/check/token",
          _body: Obj,
        })
        .then((res) => {
          if (res) {
            this.isShow = true;
            this.loader = false;
          }
          // else {
          //     this.loader = false;
          //   }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // switchVisibilityOld() {
    //   this.oldPasswordFieldType =
    //     this.oldPasswordFieldType === "password" ? "text" : "password";
    //   this.imageOld =
    //     this.imageOld === "/images/show-psw.svg"
    //       ? "/images/hide-psw.svg"
    //       : "/images/show-psw.svg";
    // },
    switchVisibilityNew() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.imageNew =
        this.imageNew === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    switchVisibility() {
      this.PasswordFieldType =
        this.PasswordFieldType === "password" ? "text" : "password";
      this.image =
        this.image === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    resetPassword() {
      this.reset.token = this.token;
      this.$api
        .putAPI({
          _action: "/set/password",
          _body: this.reset,
          _buttonId: "submit-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$router.push("/home");
        })
        .catch(() => {
          //   this.loader = false;
        });
    },
  },
};
</script>

<style>
</style>